
var id = "copy";
var markup = "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"copy\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24C5.3724 24 0 18.6276 0 12ZM2.4 12C2.4 17.3016 6.6984 21.6 12 21.6C17.3016 21.6 21.6 17.3016 21.6 12C21.6 6.6984 17.3016 2.4 12 2.4C6.6984 2.4 2.4 6.6984 2.4 12Z\" fill=\"#1565C0\" />\n<g clip-path=\"url(#copy_clip0_1314_63837)\">\n<path d=\"M7.5 9.12891H14.25C14.4489 9.12891 14.6397 9.20792 14.7803 9.34858C14.921 9.48923 15 9.67999 15 9.87891V16.6289C15 16.8278 14.921 17.0186 14.7803 17.1592C14.6397 17.2999 14.4489 17.3789 14.25 17.3789H7.5C7.30109 17.3789 7.11032 17.2999 6.96967 17.1592C6.82902 17.0186 6.75 16.8278 6.75 16.6289V9.87891C6.75 9.67999 6.82902 9.48923 6.96967 9.34858C7.11032 9.20792 7.30109 9.12891 7.5 9.12891Z\" fill=\"#1565C0\" />\n<path d=\"M16.5 6.87891C16.6989 6.87891 16.8897 6.95792 17.0303 7.09858C17.171 7.23923 17.25 7.42999 17.25 7.62891V14.3789C17.25 14.5778 17.171 14.7686 17.0303 14.9092C16.8897 15.0499 16.6989 15.1289 16.5 15.1289H15.75V9.12891C15.7501 8.93969 15.6786 8.75744 15.5499 8.6187C15.4213 8.47996 15.2449 8.39497 15.0562 8.38078L15 8.37891H9V7.62891C9 7.42999 9.07902 7.23923 9.21967 7.09858C9.36032 6.95792 9.55109 6.87891 9.75 6.87891H16.5Z\" fill=\"#1565C0\" />\n</g>\n<defs>\n<clipPath id=\"copy_clip0_1314_63837\">\n<rect width=\"12\" height=\"12\" fill=\"white\" transform=\"translate(6 6.12891)\" />\n</clipPath>\n</defs>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
